import { TextField, Box, Typography } from "@mui/material";
import MoedaInput from "../../../../util/ui/inputs/moedaInput";

type Props = {
  setPropriedadeNota: (nome: string, valor: any) => void;
  taxaLiquidacao?: number;
  taxaRegistro?: number;
  emolumentos?: number;
  readOnly: boolean;
};

export default function CustosBovespa({
  setPropriedadeNota,
  taxaLiquidacao,
  taxaRegistro,
  emolumentos,
  readOnly,
}: Props) {
  return (
    <Box
      display={"flex"}
      flexDirection="column"
      width="100%"
      paddingX={1}
      paddingY={2}
    >
      {/* Section header do sistema: eyebrow mono tracked sobre hairline. */}
      <Box
        borderBottom={1}
        borderColor="divider"
        paddingBottom={1}
        marginBottom={1.5}
      >
        <Typography variant="eyebrow" color="text.secondary">
          Custos Bovespa
        </Typography>
      </Box>
      <Box
        display={"flex"}
        flexDirection="row"
        justifyContent={"space-between"}
        alignItems="center"
      >
        <Box flexBasis="75%" paddingRight={1}>
          <Typography variant="labelMono" color="text.secondary">
            Taxa de Liquidação
          </Typography>
        </Box>
        <TextField
          id="standard-taxaLiquidacao"
          size="small"
          InputLabelProps={{
            shrink: true,
          }}
          variant="outlined"
          value={taxaLiquidacao}
          disabled={readOnly}
          onChange={(e) =>
            //@ts-ignore
            setPropriedadeNota("taxaLiquidacao", e.target.floatValue)
          }
          InputProps={{
            inputComponent: MoedaInput,
          }}
        />
      </Box>
      <Box
        display={"flex"}
        flexDirection="row"
        justifyContent={"space-between"}
        alignItems="center"
        paddingTop={1}
      >
        <Box flexBasis="75%" paddingRight={1}>
          <Typography variant="labelMono" color="text.secondary">
            Taxa de Registro
          </Typography>
        </Box>
        <TextField
          id="standard-taxaRegistro"
          size="small"
          InputLabelProps={{
            shrink: true,
          }}
          variant="outlined"
          value={taxaRegistro}
          disabled={readOnly}
          onChange={(e) =>
            //@ts-ignore
            setPropriedadeNota("taxaRegistro", e.target.floatValue)
          }
          InputProps={{
            inputComponent: MoedaInput,
          }}
        />
      </Box>
      <Box
        display={"flex"}
        flexDirection="row"
        justifyContent={"space-between"}
        alignItems="center"
        paddingTop={1}
      >
        <Box flexBasis="75%" paddingRight={1}>
          <Typography variant="labelMono" color="text.secondary">
            Emolumentos
          </Typography>
        </Box>
        <TextField
          id="standard-emolumentos"
          size="small"
          InputLabelProps={{
            shrink: true,
          }}
          variant="outlined"
          value={emolumentos}
          disabled={readOnly}
          onChange={(e) =>
            //@ts-ignore
            setPropriedadeNota("emolumentos", e.target.floatValue)
          }
          InputProps={{
            inputComponent: MoedaInput,
          }}
        />
      </Box>
    </Box>
  );
}
